import { render, staticRenderFns } from "./HighlightedDocumentItem.vue?vue&type=template&id=3329d588&"
import script from "./HighlightedDocumentItem.vue?vue&type=script&lang=js&"
export * from "./HighlightedDocumentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports